import createActionHelper from './createActionHelper';
import { PUSH_OPEN_ID } from '../constants/sidebar';

export function pushOpenedId(id) {
  return createActionHelper(PUSH_OPEN_ID)(id);
}
